

import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from '../../src/redux/reducers';

export const ShippingDetail = (props:any) => {

    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    let payment:any = useRef(0); 

    let shippingInfo = {
        '472': {
            costo_total: 0,
            operador: ""
        },
        'tcc': {
            costo_total: 0,
            operador: ""
        },
    }
    
    if (props.shipping && props.shipping['472'] != null && !homeState.freeDelivery){
        shippingInfo['472'] = {
            costo_total: props.shipping['472'].costo_total,
            operador: props.shipping['472'].operador
        }
        payment =  shippingInfo['472'].costo_total + props.totalAmount;
    }
    else{
        payment =  shippingInfo['tcc'].costo_total + props.totalAmount;
    }
    

    if (props.shipping && props.shipping['tcc'] != null && !homeState.freeDelivery){
        shippingInfo['tcc'] = {
            costo_total: props.shipping['tcc'].costo_total,
            operador: props.shipping['tcc'].operador
        }
        payment =  shippingInfo['tcc'].costo_total + props.totalAmount;
    }
    else{
        payment =  shippingInfo['472'].costo_total + props.totalAmount;
    }
    if (props.shipping && props.shipping['tcc'] != null && props.shipping['472'] != null && !homeState.freeDelivery){

        payment =  shippingInfo['tcc'].costo_total + shippingInfo['472'].costo_total + props.totalAmount;
    
    } 

    return payment;
}

export const ShippingInfo = (props:any) => {

    const homeState: HomeStateType = useSelector((state: RootState) => state.home);


    let shippingInfo = {
        '472': {
            costo_total: 0,
            operador: ""
        },
        'tcc': {
            costo_total: 0,
            operador: ""
        },
    }
    
    if (props.shipping && props.shipping['472'] != null && !homeState.freeDelivery){
        shippingInfo['472'] = {
            costo_total: props.shipping['472'].costo_total,
            operador: props.shipping['472'].operador
        }
    }
   
    

    if (props.shipping && props.shipping['tcc'] != null && !homeState.freeDelivery){
        shippingInfo['tcc'] = {
            costo_total: props.shipping['tcc'].costo_total,
            operador: props.shipping['tcc'].operador
        }
        
    }
    return shippingInfo;
}